var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(-34 -1066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    d: "M3,1A2,2,0,0,0,1,3v9a2,2,0,0,0,2,2h9a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H3M3,0h9a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(34 1066)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(-4472.627 2593.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M4514.743-1513.168c0-.043-.005-.086-.005-.13q0-2.21,0-4.42c0-.1-.029-.127-.128-.125-.45.005-.9,0-1.35,0-.076,0-.1-.018-.1-.1q.006-.81,0-1.62c0-.082.02-.107.1-.106.453,0,.906,0,1.36,0,.095,0,.115-.03.114-.119,0-.48-.012-.96.008-1.44a2.278,2.278,0,0,1,.6-1.529,2.1,2.1,0,0,1,1.126-.6,4.394,4.394,0,0,1,1.1-.052c.272.011.545.037.818.051.075,0,.1.027.1.106q-.006.72,0,1.44c0,.084-.029.095-.1.1-.36,0-.72-.016-1.08.014a.659.659,0,0,0-.677.692c-.015.423,0,.846-.01,1.27,0,.081.047.072.1.072.53,0,1.06,0,1.59,0,.1,0,.115.024.1.117q-.11.807-.208,1.615c-.01.079-.044.094-.115.093-.457,0-.914,0-1.37,0-.073,0-.1.018-.1.095q0,2.26,0,4.52c0,.02,0,.04,0,.059Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook1.91aad3ceeb9a8ee53fe958493cb09ddf.svg";
export { ForwardRef as ReactComponent };